// src/App.js
import React, { useState, useEffect } from 'react'; // <-- ADD useEffect here
import { BrowserRouter as Router, Routes, Route, NavLink } from 'react-router-dom';
import './App.css'; // Existing CSS

import ScrollToTop from './utils/ScrollToTop';

import HomePage from './pages/HomePage';
import InteractiveWalkthroughPage from './pages/InteractiveWalkthroughPage';
import SafetyTipsPage from './pages/SafetyTipsPage';
import SupportPage from './pages/SupportPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsAndConditionsPage from './pages/TermsAndConditionsPage';
// import ComingSoonPage from './pages/ComingSoonPage';
import SingleListingPage from './pages/SingleListingPage';
import RoommateConnectPage from './pages/RoommateConnectPage';
import BlogPage from './pages/BlogPage';
import SingleBlogPostPage from './pages/SingleBlogPostPage';

// Admin routes - keeping original, as per your instruction
import ListingsLogin from './pages/ListingsLogin';
import ListingsDashboard from './pages/ListingsDashboard';

// NEW Lister routes - keeping original
import { AuthProvider } from './hooks/useAuth'; // NEW import for Auth Context

import logo from './images/logo.jpg';
import { FaInstagram, FaXTwitter, FaLinkedin, FaWhatsapp, FaXmark } from 'react-icons/fa6'; // <-- ADD FaXmark

import FacebookPixelTracker from './components/FacebookPixelTracker';

// --- NEW IMPORTS FOR THE LEAD FORM ---
import LeadFormPage from './pages/LeadFormPage'; 
import ThankYouPage from './pages/ThankYouPage';

import SafetyStandardsPage from './pages/SafetyStandardsPage';

function App() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // NEW STATE: Control visibility of the one-time pop-up
  const [showWhatsappPopup, setShowWhatsappPopup] = useState(false); 

  // --- WHATSAPP CONFIGURATION ---
  const whatsappNumber = '919569994536'; // Your actual number
  const whatsappMessage = 'Hi RoomEase, I saw your website and have a question.';
  const encodedMessage = encodeURIComponent(whatsappMessage);
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
  // -------------------------------

  const androidLink = "https://play.google.com/store/apps/details?id=com.roomease.roomate&hl=en_IN";
  const iosLink = "https://apps.apple.com/my/app/roomease-roommate-finder/id6743614619";

  // NEW EFFECT: Check localStorage to show the popup only once
  useEffect(() => {
    const hasSeenPopup = localStorage.getItem('hasSeenWhatsappPopup');
    if (!hasSeenPopup) {
      // Show the popup after a small delay (e.g., 2 seconds) for better UX
      const timer = setTimeout(() => {
        setShowWhatsappPopup(true);
      }, 2000); 

      return () => clearTimeout(timer); // Cleanup function
    }
  }, []);

  // NEW FUNCTION: Dismiss the popup permanently
  const handlePopupDismiss = () => {
    setShowWhatsappPopup(false);
    localStorage.setItem('hasSeenWhatsappPopup', 'true');
  };
  
  // NEW FUNCTION: Dismiss the popup when the floating button is clicked
  const handleWhatsappClick = () => {
    // Dismiss the popup when the user interacts with the main button
    handlePopupDismiss(); 
    // The link itself handles navigation via the <a> tag
  };


  const handleDownloadClick = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    let os = "unknown";

    if (/android/i.test(userAgent)) {
      os = "Android";
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      os = "iOS";
    }

    if (window.fbq) {
      window.fbq('track', 'Lead', {
        content_name: 'Header Download App Button Click',
        source_os: os,
      });
      console.log(`Facebook Pixel: Lead event fired for Header Download App Button (${os}).`);
    } else {
      console.warn('Facebook Pixel: fbq not found, Header Download App event not tracked.');
    }

    if (os === "Android") {
      window.location.href = androidLink;
    } else if (os === "iOS") {
      window.location.href = iosLink;
    } else {
      window.location.href = "https://linktr.ee/roomeaseindia";
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <Router>
      <FacebookPixelTracker />
      <ScrollToTop />

      <header className="hero-header">
        <div className="header-branding">
          <img src={logo} alt="RoomEase Logo" className="header-logo" />
          <span className="header-name">RoomEase</span>
        </div>

        <button
          className={`hamburger-menu ${isMobileMenuOpen ? 'is-active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation menu"
        >
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </button>

        <nav className={`header-nav ${isMobileMenuOpen ? 'is-open' : ''}`}>
          <NavLink
            to="/"
            className={({ isActive }) => (isActive ? 'nav-link nav-link-active' : 'nav-link')}
            onClick={closeMobileMenu}
            end
          >
            Home
          </NavLink>
          <NavLink
            to="/walkthrough"
            className={({ isActive }) => (isActive ? 'nav-link nav-link-active' : 'nav-link')}
            onClick={closeMobileMenu}
          >
            Walkthrough
          </NavLink>
          <NavLink
            to="/safetytips"
            className={({ isActive }) => (isActive ? 'nav-link nav-link-active' : 'nav-link')}
            onClick={closeMobileMenu}
          >
            Safety Tips
          </NavLink>
          <NavLink
            to="/listings"
            className={({ isActive }) => (isActive ? 'nav-link nav-link-active' : 'nav-link')}
            onClick={closeMobileMenu}
          >
            Listings
          </NavLink>
          
          <button className="download-app-header-button mobile-hidden" onClick={handleDownloadClick}>
            Download App
          </button>
        </nav>

        <button className="download-app-header-button desktop-only" onClick={handleDownloadClick}>
          Download App
        </button>
      </header>

      <div className="App-content-wrapper">
        <AuthProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/walkthrough" element={<InteractiveWalkthroughPage />} />
            <Route path="/safetytips" element={<SafetyTipsPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/tnc" element={<TermsAndConditionsPage />} />
            <Route path="/listings" element={<RoommateConnectPage />} />
            <Route path="/listings/:slug" element={<SingleListingPage />} />
            <Route path="/blogs" element={<BlogPage />} />
            <Route path="/blogs/:slug" element={<SingleBlogPostPage />} />
            
            {/* --- NEW ROUTES FOR THE LEAD FORM AND THANK YOU PAGE --- */}
            <Route path="/move-in" element={<LeadFormPage />} />
            <Route path="/thank-you" element={<ThankYouPage />} />

            {/* Existing Admin routes - unchanged */}
            <Route path="/listingslogin" element={<ListingsLogin />} />
            <Route path="/listingsdashboard" element={<ListingsDashboard />} />

            <Route path="/safety-standards" element={<SafetyStandardsPage />} />
          </Routes>
        </AuthProvider>
      </div>

      {/* ------------------------------------------------------------- */}
      {/* --- WHATSAPP POP-UP DIALOGUE (Conditional) AND FLOAT BUTTON --- */}
      {/* ------------------------------------------------------------- */}
      
      {showWhatsappPopup && (
        <div className="whatsapp-popup-dialogue">
          <p className="whatsapp-popup-text">
            Need help finding a roommate? <b>Chat with us!</b>
          </p>
          <button 
            className="whatsapp-popup-close-btn" 
            onClick={handlePopupDismiss}
            aria-label="Close chat prompt"
          >
            <FaXmark size={16} />
          </button>
        </div>
      )}

      <a 
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float-button"
        aria-label="Chat with us on WhatsApp"
        onClick={handleWhatsappClick}
      >
        <FaWhatsapp size={32} />
      </a>
      {/* ------------------------------------------------------------- */}

      <footer className="main-footer">
        <div className="container" style={{ backgroundColor: 'rgba(255, 255, 255, 0.9)' }}>
          <div className="footer-social-links">
            <a href="https://www.instagram.com/roomease.india/" target="_blank" rel="noopener noreferrer">
              <FaInstagram size={24} />
            </a>
            <a href="https://x.com/roomease_india" target="_blank" rel="noopener noreferrer">
              <FaXTwitter size={24} />
            </a>
            <a href="https://www.linkedin.com/company/roomeaseindia/" target="_blank" rel="noopener noreferrer">
              <FaLinkedin size={24} />
            </a>
          </div>

          <div className="footer-links">
            <a href="mailto:roomease.work@gmail.com">Contact</a>
            <NavLink
              to="/blogs"
              className={({ isActive }) => (isActive ? 'footer-link footer-link-active' : 'footer-link')}
              onClick={closeMobileMenu}
            >
              Blogs
            </NavLink>
            <a href="https://forms.gle/NDptXxJznarB2eVn9">Careers</a>
            <NavLink
              to="/support"
              className={({ isActive }) => (isActive ? 'footer-link footer-link-active' : 'footer-link')}
            >FAQs</NavLink>
            <NavLink
              to="/privacy-policy"
              className={({ isActive }) => (isActive ? 'footer-link footer-link-active' : 'footer-link')}
            >Privacy</NavLink>
            <NavLink
              to="/safety-standards"
              className={({ isActive }) => (isActive ? 'footer-link footer-link-active' : 'footer-link')}
            >Safety Standards</NavLink>
            <NavLink
              to="/tnc"
              className={({ isActive }) => (isActive ? 'footer-link footer-link-active' : 'footer-link')}
            >T&C</NavLink>
          </div>
          
          <p>© 2025 RoomEase. All rights reserved.</p>
        </div>
      </footer>
    </Router>
  );
}

export default App;